export const ServiceStatusConstant = {
	GET_STATUS_SUCCESS: 'SS_GET_STATUS_SUCCESS',
	GET_STATUS_FAIL: 'SS_GET_STATUS_FAIL',
	GET_COUNTS_SUCCESS: 'SS_GET_COUNTS_SUCCESS',
	GET_COUNTS_FAIL: 'SS_GET_COUNTS_FAIL',
	SET_ENABLED_SUCCESS: 'SS_SET_ENABLED_SUCCESS',
	LOADING: 'SS_LOADING',
	LOADED: 'SS_LOADED',
	WS_CONNECTED: 'SS_WS_CONNECTED',
	WS_DISCONNECTED: 'SS_WS_DISCONNECTED',
};
